import type { FC } from 'react';

import { Link } from 'src/shared/components/link/link.js';

import { cnPageInternalLogin } from '../page-internal-login.constants.js';

import './page-internal-login__help.css';

export interface PageInternalLoginHelpProps {}

export const PageInternalLoginHelp: FC<PageInternalLoginHelpProps> = () => (
    <p className={cnPageInternalLogin('help')}>
        Can’t sign in?{' '}
        <Link
            href="https://coding-bootcamps.notion.site/Keycloak-Sign-in-2506ed1efc9380be9c83e1dcd5495c37"
            target="_blank"
            rel="noopener noreferrer"
        >
            Read recent updates
        </Link>
    </p>
);
